<template>
  <div class="common-pagination">
    <Paginator
      :rows="rows"
      :totalRecords="totalRecords"
      :template="customTemplate"
      :currentPageReportTemplate="currentPageReportTemplate"
      :first="first"
      @page="onPageChange($event)"
    />
  </div>
</template>

<script>
export default {
  name: 'DataTablePaginator',
  props: {
    rows: {
      type: Number,
      default: 12
    },
    totalRecords: {
      type: Number,
      required: true
    },
    first: {
      type: Number,
      default: 0
    },
    customTemplate: {
      type: String,
      default: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
    },
    currentPageReportTemplate: {
      type: String,
      default: "Showing {first} to {last} of {totalRecords}"
    }
  },
  methods: {
    onPageChange(event) {
      this.$emit('first-update', event.first);
    }
  }
}
</script>

<style scoped>
.common-pagination {
  margin-top: 20px;
  width: 100%;
  nav{
    width: 100%;
  }
}

@media (max-width: 576px) {
  .common-pagination {
    padding: 0.5rem;
    margin-top: 1rem;
  }
  
  ::v-deep(.p-paginator .p-paginator-current) {
    font-size: 12px;
    display: none; /* Hide on very small screens to save space */
  }
  
  ::v-deep(.p-paginator-page),
  ::v-deep(.p-paginator-first),
  ::v-deep(.p-paginator-prev),
  ::v-deep(.p-paginator-next),
  ::v-deep(.p-paginator-last) {
    min-width: 2rem;
    height: 2rem;
  }
  
  ::v-deep(.p-paginator) {
    justify-content: space-between !important;
  }
}
</style> 